import {
	Attempt, ElibraryItemDataSource, Product, Question
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyLocalDatabase } from "./idb";
import {
	AnswerValue, ContentItem, PqItemUsage, UsageMode
} from "@sabyr-dev/mist_core/model/datasource/item";
import { Annotations } from "@sabyr-dev/mist_core/lib/userdata";
import { AcademyAttemptState } from "./state";
import { deepMerge } from "@sabyr-dev/mist_core/model/datasource/state";

import { getAttemptId } from "./academy";

interface ElibraryFinishedType {
	result?: string;
}

export class AcademyItemDataSource extends ElibraryItemDataSource {
	local: AcademyLocalDatabase;

	constructor() {
		super();
		this.local = new AcademyLocalDatabase();
	}

	getItem(product: Product, question: Question, randomize: boolean): Promise<ContentItem<Question>> {
		return super.getItem(product, question, randomize);
	}

	async setUserData(product: Product, attempt: Attempt, question: Question, data: Annotations): Promise<AnswerValue<Attempt, Question>> {
		const db = await this.local.getDb();
		// TODO: Figure out how to mark questions correct as they are answered. Data is in lib/content
		await this.local.write(AcademyLocalDatabase.attempt, question, async (transaction) => {
			const state = await transaction.store.get(this.local.getAttemptKey()) as AcademyAttemptState;
			const newState = deepMerge({
				...state,
				userData: state?.userData ?? {}
			}, {
				userData: {
					[question]: data
				}
			});
			await transaction.store.put(newState, this.local.getAttemptKey());
			return true;
		});
		return {
			id: question,
			attempt_id: getAttemptId(),
			item_id: question,
			name: question,
			answer: data.answer.toString(),
			correct: false
		};
	}

	setPing(product: Product, attempt: Attempt, mode: UsageMode, times: PqItemUsage<Question>[]): Promise<void> {
		return Promise.resolve();
		//return super.setPing(product, attempt, mode, times);
	}

	// @ts-ignore
	async setFinished(product: Product, attempt: Attempt, total_time: number): Promise<string> {
		const db = await this.local.getDb();
		const state = await db.get(
			AcademyLocalDatabase.attempt, this.local.getAttemptKey()
		) as AcademyAttemptState;
		const answers = Array.from(
			document.querySelectorAll<HTMLElement>('.item-list .item')
		).reduce((result, element) => ({
			...result,
			...(state.userData[element.dataset.id].answer ? {
				[element.dataset.id]: {
					answer: state.userData[element.dataset.id].answer,
					correct: state.userData[element.dataset.id].status == 'correct'
				}
			} : {})
		}), {});
		const response = await fetch(
			`/practicequestion/finish/${product}/${attempt}`,
			{
				method: 'POST',
				redirect: 'manual',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ total_time, answers })
			}
		);
		const result = await response.json() as ElibraryFinishedType;
		return result.result;
	}
}
